import { Component, Input } from '@angular/core';
import { TunnelCartLine } from '../../models/tunnel-cart-line';

/** Liste compacte des produits retenus dans la liste d'achat. */
@Component({
  selector: 'ng-casto-tunnel-cart-list',
  templateUrl: './tunnel-cart-list.component.html',
  styleUrls: ['./tunnel-cart-list.component.scss'],
})
export class TunnelCartListComponent {
  @Input() lines: TunnelCartLine[] = [];
}
